/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Autosignin2Inputs */

const en_entity_autosignin2 = /** @type {(inputs: Entity_Autosignin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Sign-In`)
};

const de_entity_autosignin2 = /** @type {(inputs: Entity_Autosignin2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Anmeldung`)
};

/**
* | output |
* | --- |
* | "Auto Sign-In" |
*
* @param {Entity_Autosignin2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_autosignin2 = /** @type {((inputs?: Entity_Autosignin2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Autosignin2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_autosignin2(inputs)
	return de_entity_autosignin2(inputs)
});
export { entity_autosignin2 as "entity_autoSignIn" }